import styled from 'styled-components';
import Colors from '../../../../styles/colors';

export const RowDivision = styled.div`
  padding: 10px 0;
`;

export const HelperText = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
`;

export const DivisionHeadline = styled.div`
  padding: 20px 20px 0;

  .headline {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const DivisionLabel = styled.div`
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0 0 10px;
`;

export const Select = styled.select`
  appearance: none;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAJFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///+m5iRVAAAACnRSTlMADQ9XWHx9fn+A42dm/AAAAE9JREFUeNrtzDkSgEAQw0BzY/7/YEJHW7XMJATqXBIAAH+37iPboil+Bg5NcrEPD/rW4dQnLvbhVp9D+tbhUonTFzl953CrwemLfAsAgHkv2uIHTO2ldWkAAAAASUVORK5CYII=');
  background-repeat: no-repeat;
  background-position: right center;
  background-size: 25px;
  padding-right: 35px !important;
`;

export const MultiCheckbox = styled.div`
  background-color: #fff;
  border-radius: 8px;

  .all-checkbox {
    padding: 11px 20px;
    background-color: #fff;
    border-bottom: 1px solid #f0f0f0;
  }

  .child-checkboxes {
    height: 300px;
    overflow-y: auto;
    padding: 10px 20px;
  }
`;

export const BaseButton = styled.button`
  font-size: 16px;
  width: 160px;
  height: 40px;
  border-radius: 10px;
  margin: 30px auto 0px;
  cursor: pointer;
  display: flex !important;
  justify-content: center;
  align-items: center;
`;

export const PublishButton = styled(BaseButton)`
  background-color: ${Colors.mainOrange};
  color: ${Colors.mainWhite};

  &:hover {
    color: ${Colors.mainWhite};
  }
`;

export const DraftButton = styled(BaseButton)`
  background-color: ${Colors.link};
  color: ${Colors.fontBlack};
`;

export const UploaderActionButtons = styled.div`
  background-color: rgba(7, 7, 7, 0.6);
  width: 100%;
  height: 60px;
  color: rgb(255, 255, 255);
  font-size: 18px;
  border: 0px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;

  .action-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;

    .icon-button {
      margin: 0 10px;

      span.material-icons {
        display: inline-block;
        padding: 5px;
        background-color: #e0e0e0;
        color: #6a6a6a;
        border-radius: 17px;
        cursor: pointer;
        transition: all 0.8s cubic-bezier(0.2, 0.8, 0.18, 0.93) 0s;

        &:hover {
          color: #424242;
          background-color: #fff;
          transform: translateY(-1.5px);
        }
      }
    }
  }
`;
